import { Outlet, ScrollRestoration } from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'
import { ErrorBoundary } from 'react-error-boundary'
import { z } from 'zod'
import { GlobalError } from '~/components/layout/GlobalError/GlobalError'
import { GlobalLayout } from '~/components/layout/GlobalLayout/GlobalLayout'
import { customErrorMap } from '~/lib/zod/customError'

z.config({ customError: customErrorMap })

export function App() {
  return (
    <>
      {/**
       * ScrollRestoration を入れることで iOS Safari における画面を戻った際に画面が白く描画される問題を解決する
       * https://kaminashi.atlassian.net/browse/INE-2096
       */}
      <ScrollRestoration />
      <CssBaseline />
      <ErrorBoundary FallbackComponent={GlobalError}>
        <GlobalLayout>
          <Outlet />
        </GlobalLayout>
      </ErrorBoundary>
    </>
  )
}
